// First-party funnel step tracking → POST /api/events → Admin → Funnel.
//
// Same philosophy as utils/attribution.js: no third-party script, nothing sent anywhere
// but our own server, and strictly best-effort — tracking can never break or slow a page.
// A random visitor id in localStorage lets one visitor's steps be followed through to a
// purchase; no email, name or IP is collected here.

const ANON_KEY = 'se_anon';

function anonId() {
  try {
    let id = localStorage.getItem(ANON_KEY);
    if (!id) {
      id = (window.crypto && crypto.randomUUID) ? crypto.randomUUID()
        : `a${Date.now().toString(36)}${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem(ANON_KEY, id);
    }
    return id;
  } catch { return null; }
}

// Skip the build-time prerender (react-snap's headless Chrome) — those aren't visitors.
const isPrerender = () =>
  typeof window === 'undefined' || /ReactSnap|HeadlessChrome/i.test(navigator.userAgent || '');

export function track(event, detail) {
  try {
    if (isPrerender()) return;
    const id = anonId();
    if (!id) return;
    const headers = { 'Content-Type': 'application/json' };
    const token = localStorage.getItem('se_token');
    if (token) headers.Authorization = `Bearer ${token}`;
    fetch(`${process.env.REACT_APP_API_URL || '/api'}/events`, {
      method: 'POST',
      headers,
      keepalive: true, // survives navigating away (e.g. the hand-off to Stripe)
      body: JSON.stringify({
        anonId: id,
        event,
        path: window.location.pathname,
        detail: detail == null ? undefined : String(detail),
      }),
    }).catch(() => {});
  } catch { /* never let tracking throw */ }
}
